import React from "react";
import { Modal, Descriptions, Tag, Space, Badge } from "antd";
import { UserSwitchOutlined, SafetyOutlined, UserOutlined } from "@ant-design/icons";
import moment from "moment";

const LogDetailModal = ({ visible, log, onClose }) => {
  if (!log) return null;

  const isImpersonated = log.impersonated === true;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      title={
        <Space>
          {isImpersonated ? (
            <SafetyOutlined style={{ color: "#722ed1" }} />
          ) : (
            <UserOutlined style={{ color: "#1890ff" }} />
          )}
          <span>Activity Log Details</span>
          {isImpersonated && (
            <Tag color="purple" style={{ marginLeft: 8 }}>Impersonated Session</Tag>
          )}
        </Space>
      }
    >
      <Descriptions 
        bordered 
        column={1} 
        size="middle"
        labelStyle={{ 
          fontWeight: 600, 
          width: 140,
          backgroundColor: "#fafafa"
        }}
        contentStyle={{ backgroundColor: "white" }}
      >
        <Descriptions.Item label="User">
          <Space>
            <span style={{ fontWeight: 500 }}>{log.actor_name}</span>
            <Tag>{log.actor_role}</Tag>
            {isImpersonated && (
              <Badge status="processing" text="Impersonated" />
            )}
          </Space>
        </Descriptions.Item>
        
        {isImpersonated && log.performed_by_name && (
          <Descriptions.Item label="Performed By">
            <Space>
              <div style={{ 
                width: 24, 
                height: 24, 
                borderRadius: 12, 
                background: "#f9f0ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <UserSwitchOutlined style={{ color: "#722ed1", fontSize: 14 }} />
              </div>
              <span style={{ fontWeight: 500, color: "#722ed1" }}>
                {log.performed_by_name}
              </span>
              {/* <Badge status="success" text={} /> */}
            </Space>
          </Descriptions.Item>
        )}
        
        <Descriptions.Item label="Action">
          <Tag color={isImpersonated ? "purple" : "blue"} style={{ padding: "2px 12px" }}>
            {log.action}
          </Tag>
        </Descriptions.Item>
        
        <Descriptions.Item label="Endpoint">
          <code style={{ 
            backgroundColor: "#f5f5f5", 
            padding: "4px 8px", 
            borderRadius: 4,
            color: "#1f2937",
            wordBreak: "break-all"
          }}>
            {log.endpoint}
          </code>
        </Descriptions.Item>
        
        <Descriptions.Item label="Method">
          <Tag color={
            log.method === 'GET' ? 'cyan' :
            log.method === 'POST' ? 'green' :
            log.method === 'PUT' ? 'orange' :
            log.method === 'PATCH' ? 'blue' :
            log.method === 'DELETE' ? 'red' : 'default'
          }>
            {log.method}
          </Tag>
        </Descriptions.Item>
        
        <Descriptions.Item label="Status">
          <Tag color={
            String(log.status_code).startsWith('2') ? 'success' :
            String(log.status_code).startsWith('4') ? 'warning' :
            String(log.status_code).startsWith('5') ? 'error' : 'default'
          }>
            {log.status_code}
          </Tag>
        </Descriptions.Item>
        
        <Descriptions.Item label="IP Address">
          <span style={{ fontFamily: "monospace" }}>{log.ip_address}</span>
        </Descriptions.Item>
        
        <Descriptions.Item label="Timestamp">
          <Space direction="vertical" size={0}>
            <span>{moment(log.created_at).format("YYYY-MM-DD HH:mm:ss")}</span>
            <span style={{ fontSize: 12, color: "#6b7280" }}>
              {moment(log.created_at).fromNow()}
            </span>
          </Space>
        </Descriptions.Item>

        {log.payload && (
          <Descriptions.Item label="Payload">
            <pre style={{ 
              backgroundColor: "#f5f5f5", 
              padding: 12, 
              borderRadius: 4,
              margin: 0,
              maxHeight: 300,
              overflow: "auto"
            }}>
              {JSON.stringify(log.payload, null, 2)}
            </pre>
          </Descriptions.Item>
        )}
      </Descriptions>
    </Modal>
  );
};

export default LogDetailModal;